// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_access_requests_defaults.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { Empty } from "../../../../google/protobuf/empty";
/**
 * @generated from protobuf message c1.api.app.v1.AppAccessRequestDefaultsRef
 */
export interface AppAccessRequestDefaultsRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAccessRequestDefaults
 */
export interface AppAccessRequestDefaults {
    /**
     * The app id for the app access request rule
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The policy id for the emergency grant policy.
     *
     * @generated from protobuf field: string emergency_grant_policy_id = 2
     */
    emergencyGrantPolicyId: string;
    /**
     * If emergency grants are enabled for this app access request rule.
     *
     * @generated from protobuf field: bool emergency_grant_enabled = 3
     */
    emergencyGrantEnabled: boolean;
    /**
     * The max duration for the app access request rule.
     *
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If this app access request rule does not have a max duration, this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 10
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If this app access request rule has a max duration, this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 11
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * The request catalog ids for the app access request rule.
     *
     * @generated from protobuf field: repeated string catalog_ids = 4
     */
    catalogIds: string[];
    /**
     * If true the app level request configuration will be applied to specified resource types.
     *
     * @generated from protobuf field: bool defaults_enabled = 5
     */
    defaultsEnabled: boolean;
    /**
     * The last applied state of the app access request defaults.
     *
     * @generated from protobuf field: c1.api.app.v1.AppAccessRequestDefaultsLastApplyState state = 6
     */
    state: AppAccessRequestDefaultsLastApplyState;
    /**
     * The app resource type ids for which the app access request defaults are applied.
     *
     * @generated from protobuf field: repeated string resource_type_ids = 7
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: string request_policy_id = 8
     */
    requestPolicyId: string;
    /**
     * The ID of the request schema to apply to entitlements matching this rule.
     *
     * @generated from protobuf field: string request_schema_id = 9
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAccessRequestDefaultsRequest
 */
export interface GetAccessRequestDefaultsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CancelAccessRequestDefaultsRequest
 */
export interface CancelAccessRequestDefaultsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppAccessRequestDefaultsLastApplyState
 */
export enum AppAccessRequestDefaultsLastApplyState {
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_SUCCESS = 2;
     */
    SUCCESS = 2,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_FAILED = 3;
     */
    FAILED = 3,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCELING = 4;
     */
    CANCELING = 4,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCEL_SUCCESS = 5;
     */
    CANCEL_SUCCESS = 5,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCEL_ERROR = 6;
     */
    CANCEL_ERROR = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class AppAccessRequestDefaultsRef$Type extends MessageType<AppAccessRequestDefaultsRef> {
    constructor() {
        super("c1.api.app.v1.AppAccessRequestDefaultsRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppAccessRequestDefaultsRef>): AppAccessRequestDefaultsRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppAccessRequestDefaultsRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAccessRequestDefaultsRef): AppAccessRequestDefaultsRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAccessRequestDefaultsRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccessRequestDefaultsRef
 */
export const AppAccessRequestDefaultsRef = new AppAccessRequestDefaultsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAccessRequestDefaults$Type extends MessageType<AppAccessRequestDefaults> {
    constructor() {
        super("c1.api.app.v1.AppAccessRequestDefaults", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 11, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 4, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "defaults_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.app.v1.AppAccessRequestDefaultsLastApplyState", AppAccessRequestDefaultsLastApplyState, "APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_"] },
            { no: 7, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 9, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppAccessRequestDefaults>): AppAccessRequestDefaults {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.emergencyGrantPolicyId = "";
        message.emergencyGrantEnabled = false;
        message.maxGrantDuration = { oneofKind: undefined };
        message.catalogIds = [];
        message.defaultsEnabled = false;
        message.state = 0;
        message.resourceTypeIds = [];
        message.requestPolicyId = "";
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<AppAccessRequestDefaults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAccessRequestDefaults): AppAccessRequestDefaults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string emergency_grant_policy_id */ 2:
                    message.emergencyGrantPolicyId = reader.string();
                    break;
                case /* bool emergency_grant_enabled */ 3:
                    message.emergencyGrantEnabled = reader.bool();
                    break;
                case /* google.protobuf.Empty duration_unset */ 10:
                    message.maxGrantDuration = {
                        oneofKind: "durationUnset",
                        durationUnset: Empty.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationUnset)
                    };
                    break;
                case /* google.protobuf.Duration duration_grant */ 11:
                    message.maxGrantDuration = {
                        oneofKind: "durationGrant",
                        durationGrant: Duration.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationGrant)
                    };
                    break;
                case /* repeated string catalog_ids */ 4:
                    message.catalogIds.push(reader.string());
                    break;
                case /* bool defaults_enabled */ 5:
                    message.defaultsEnabled = reader.bool();
                    break;
                case /* c1.api.app.v1.AppAccessRequestDefaultsLastApplyState state */ 6:
                    message.state = reader.int32();
                    break;
                case /* repeated string resource_type_ids */ 7:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* string request_policy_id */ 8:
                    message.requestPolicyId = reader.string();
                    break;
                case /* string request_schema_id */ 9:
                    message.requestSchemaId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAccessRequestDefaults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string emergency_grant_policy_id = 2; */
        if (message.emergencyGrantPolicyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emergencyGrantPolicyId);
        /* bool emergency_grant_enabled = 3; */
        if (message.emergencyGrantEnabled !== false)
            writer.tag(3, WireType.Varint).bool(message.emergencyGrantEnabled);
        /* repeated string catalog_ids = 4; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.catalogIds[i]);
        /* bool defaults_enabled = 5; */
        if (message.defaultsEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.defaultsEnabled);
        /* c1.api.app.v1.AppAccessRequestDefaultsLastApplyState state = 6; */
        if (message.state !== 0)
            writer.tag(6, WireType.Varint).int32(message.state);
        /* repeated string resource_type_ids = 7; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* string request_policy_id = 8; */
        if (message.requestPolicyId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.requestPolicyId);
        /* string request_schema_id = 9; */
        if (message.requestSchemaId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.requestSchemaId);
        /* google.protobuf.Empty duration_unset = 10; */
        if (message.maxGrantDuration.oneofKind === "durationUnset")
            Empty.internalBinaryWrite(message.maxGrantDuration.durationUnset, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration duration_grant = 11; */
        if (message.maxGrantDuration.oneofKind === "durationGrant")
            Duration.internalBinaryWrite(message.maxGrantDuration.durationGrant, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccessRequestDefaults
 */
export const AppAccessRequestDefaults = new AppAccessRequestDefaults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessRequestDefaultsRequest$Type extends MessageType<GetAccessRequestDefaultsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAccessRequestDefaultsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAccessRequestDefaultsRequest>): GetAccessRequestDefaultsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccessRequestDefaultsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessRequestDefaultsRequest): GetAccessRequestDefaultsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessRequestDefaultsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAccessRequestDefaultsRequest
 */
export const GetAccessRequestDefaultsRequest = new GetAccessRequestDefaultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelAccessRequestDefaultsRequest$Type extends MessageType<CancelAccessRequestDefaultsRequest> {
    constructor() {
        super("c1.api.app.v1.CancelAccessRequestDefaultsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CancelAccessRequestDefaultsRequest>): CancelAccessRequestDefaultsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<CancelAccessRequestDefaultsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CancelAccessRequestDefaultsRequest): CancelAccessRequestDefaultsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CancelAccessRequestDefaultsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CancelAccessRequestDefaultsRequest
 */
export const CancelAccessRequestDefaultsRequest = new CancelAccessRequestDefaultsRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppAccessRequestsDefaultsService
 */
export const AppAccessRequestsDefaultsService = new ServiceType("c1.api.app.v1.AppAccessRequestsDefaultsService", [
    { name: "CreateAppAccessRequestsDefaults", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/access_request_defaults", group: "AppAccessRequestDefaults" }] } }, I: AppAccessRequestDefaults, O: AppAccessRequestDefaults },
    { name: "GetAppAccessRequestsDefaults", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/access_request_defaults", group: "AppAccessRequestDefaults" }] } }, I: GetAccessRequestDefaultsRequest, O: AppAccessRequestDefaults },
    { name: "CancelAppAccessRequestsDefaults", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/access_request_defaults/cancel", group: "AppAccessRequestDefaults" }] } }, I: CancelAccessRequestDefaultsRequest, O: AppAccessRequestDefaults }
]);
